var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-tab-viewer" },
    [
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.defaultPhoneNumber,
                  "phone-number-override": "",
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "viewer-loading" }, [
            _c("div", { staticClass: "loader-container" }, [
              _c("div", { staticClass: "loader-spinner" }),
              _vm._v(" "),
              _c("div", { staticClass: "loader-text" }, [
                _vm._v(_vm._s(_vm.$t("webTabsPage.loading"))),
              ]),
            ]),
          ])
        : _vm.error
        ? _c("div", { staticClass: "viewer-error" }, [
            _c("div", { staticClass: "error-container" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h2", { staticClass: "error-title" }, [
                _vm._v(_vm._s(_vm.$t("webTabsPage.errorTitle"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_vm.error)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "error-actions" }, [
                _c(
                  "button",
                  { staticClass: "btn-retry", on: { click: _vm.loadWebTab } },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("webTabsPage.retry")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-back",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/integrations/webtabs")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("webTabsPage.back")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm.finalUrl
        ? _c(
            "div",
            {
              staticClass: "viewer-content",
              class: { embedded: _vm.isEmbedded },
            },
            [
              !_vm.isEmbedded
                ? _c("div", { staticClass: "viewer-header" }, [
                    _c("div", { staticClass: "header-left" }, [
                      _c(
                        "button",
                        {
                          directives: [{ name: "tippy", rawName: "v-tippy" }],
                          staticClass: "btn-icon",
                          attrs: { content: "Geri" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.go(-1)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("arrow_back"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "header-info" }, [
                        _c(
                          "span",
                          {
                            staticClass: "header-icon material-icons",
                            style: { color: _vm.webTab.iconColor || "#6366f1" },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.webTab.icon) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-text" }, [
                          _c("h1", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.webTab.name)),
                          ]),
                          _vm._v(" "),
                          _vm.webTab.description
                            ? _c("span", { staticClass: "header-desc" }, [
                                _vm._v(_vm._s(_vm.webTab.description)),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "header-right" }, [
                      _c(
                        "button",
                        {
                          directives: [{ name: "tippy", rawName: "v-tippy" }],
                          staticClass: "btn-icon",
                          attrs: { content: "Yeni sekmede aç" },
                          on: { click: _vm.openInNewTab },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("open_in_new"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [{ name: "tippy", rawName: "v-tippy" }],
                          staticClass: "btn-icon",
                          attrs: { content: "Yenile" },
                          on: { click: _vm.refreshIframe },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("refresh"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [{ name: "tippy", rawName: "v-tippy" }],
                          staticClass: "btn-icon fullscreen-btn",
                          class: { active: _vm.isFullscreen },
                          attrs: {
                            content: _vm.isFullscreen
                              ? "Tam ekrandan çık"
                              : "Tam ekran",
                          },
                          on: { click: _vm.toggleFullscreen },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                _vm.isFullscreen
                                  ? "fullscreen_exit"
                                  : "fullscreen"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isEmbedded
                ? _c("div", { staticClass: "embedded-toolbar" }, [
                    _c(
                      "button",
                      {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "btn-icon-small",
                        attrs: { content: "Yeni sekmede aç" },
                        on: { click: _vm.openInNewTab },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("open_in_new"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "btn-icon-small",
                        attrs: { content: "Yenile" },
                        on: { click: _vm.refreshIframe },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("refresh"),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "iframe-container",
                  class: {
                    fullscreen: _vm.isFullscreen,
                    embedded: _vm.isEmbedded,
                  },
                },
                [
                  _c("iframe", {
                    ref: "webTabIframe",
                    staticClass: "web-tab-iframe",
                    attrs: {
                      src: _vm.finalUrl,
                      frameborder: "0",
                      allow:
                        "camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write",
                      sandbox:
                        "allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation",
                    },
                    on: { load: _vm.handleIframeLoad },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "error-icon-wrapper" }, [
      _c("span", { staticClass: "material-icons error-icon" }, [
        _vm._v("error_outline"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }